import React from 'react';

export function Home () {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
    >
      <g clipPath="url(#clip0_18974_12484)">
        <g
          stroke="#717171"
          strokeLinecap="round"
          strokeLinejoin="round"
          clipPath="url(#clip1_18974_12484)"
        >
          <path d="M27 13.88a2 2 0 00-.64-1.48L14 1 1.64 12.4A2 2 0 001 13.88V25a2 2 0 002 2h22a2 2 0 002-2V13.88zM14 16V1M1 16h26M1 21.5h7M20 21.5h7M8 27V6.54M20 27V6.54" />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_18974_12484">
          <path fill="#fff" d="M0 0H28V28H0z" />
        </clipPath>
        <clipPath id="clip1_18974_12484">
          <path fill="#fff" d="M0 0H28V28H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
